<sk-audit [domainEntityId]="userId"></sk-audit>
